module.exports = __webpack_public_path__ + "img/logo.68d3e6b5.png";